import UqbarCard from "../utils/UqbarCard.js"
import UqbarCardGrid from "../utils/UqbarCardGrid.js"
import concursoWollokGame2019 from "./imgs/concurso-wollok-game-2019.jpg"
import concursoWollokGame2021 from "./imgs/concurso-wollok-game-2021.png"
import concursoWollokGame2022 from "./imgs/concurso-wollok-game-2022.png"
import concursoWollokGame2023 from "./imgs/concurso-wollok-game-2023.png"
import concursoWollokGame2024 from "./imgs/concurso-wollok-game-2024.png"
import concursoWollokGame2025 from "./imgs/concurso-wollok-game-2025.jpg"
import convocatoriaDocente from "./imgs/convocatoria-docente.jpeg"
import encuentroVirtual from "./imgs/encuentro-virtual.jpg"
import hackathonWollokUNQ2026 from "./imgs/hackathon-wollok-UNQ-junio-2026.png"
import hackathonWollokUTN2026 from "./imgs/hackathon-wollok-UTN-marzo-2026.jpg"
import jornadasDocentes from "./imgs/jornadas-docentes.jpg"
import maquinasVirtuales2022 from "./imgs/maquinas-virtuales-2022.jpg"
import pharoOptimizations2024 from "./imgs/pharo-optimizations-2024.png"
import softwareLibre2022 from "./imgs/software-libre-2022.jpg"
import ultimoEvento2020 from "./imgs/ultimo-evento-2020.jpg"
import ultimoEvento2021 from "./imgs/ultimo-evento-2021.jpg"
import unahurTic from "./imgs/unahur-tic.jpeg"
import uqbarLogo from "./imgs/uqbar.png"
import concursoWollokGame2020 from "./imgs/votacion-concurso-wollok-game-2020.jpg"
import wollokGameUnahur2026 from "./imgs/wollok-game-unahur-2026.png"
import reunionWollok2026 from "./imgs/reunion-wollok-2026.png"

export function EventosActuales() {
  return (
    <UqbarCardGrid>
    </UqbarCardGrid>
  )
}

export default function Eventos() {
  return (
    <div className="container" id="Eventos">
      <h2>Próximos</h2>
      <EventosActuales />

      <h2>2026</h2>
      <UqbarCardGrid>
        <UqbarCard
          link="https://docs.google.com/document/d/e/2PACX-1vTa5dlHVJWd0EeziHvHWmgqFOhRAYqtPyr2YxYdcFZ9zRJetf8ruBs8lnhcesG0TV357_AF4bmS1FXQ/pub"
          projectLogo={reunionWollok2026}
          projectName="Reunión de Wollok 2026"
          projectDescription="Queremos invitarte a la próxima reunión de la comunidad de Wollok. La idea es volver a encontrarnos quienes enseñamos, aprendemos y hacemos crecer el proyecto, para ponernos al día y conversar tanto sobre el camino recorrido como sobre lo que se viene. Si este año empezaste a dar clases, sos ayudante, o usás Wollok en otra institución, también nos encantaría que te sumes: la reunión está pensada justamente para conocernos, compartir experiencias y seguir construyendo la comunidad entre todxs."
        />

        <UqbarCard
          link="https://www.instagram.com/reel/DbBErnQjleI/?igsh=aXVtNGRjM3Bydm12"
          projectLogo={wollokGameUnahur2026}
          projectName="Aprendiendo a programar creando videojuegos - Experiencia Wollok Game"
          projectDescription="El sábado 27 a las 9 hs vamos a estar en la UNAHUR compartiendo una mañana para charlar sobre Wollok Game, intercambiar experiencias y disfrutar un tiempo en comunidad. El evento es abierto a todo público. No hace falta ser experto ni haber usado Wollok Game antes. Si te interesa la enseñanza de la programación, los juegos o simplemente tenés curiosidad por ver qué estamos haciendo, sos más que bienvenidx. 🙌 ¡Vení a jugar, crear y compartir ideas!"
        />

        <UqbarCard
          link="https://discord.com/channels/737094307902914570/840658205940121601/1511739639554244851"
          projectLogo={hackathonWollokUNQ2026}
          projectName="Hackathon Wollok en UNQ"
          projectDescription="Este sábado 13 de junio nos volvemos a encontrar en la Universidad Nacional de Quilmes para una jornada de código, Wollok y comunidad 🫂. ¿Tenés ganas de contribuir, proponer ideas o sumarte a desarrollar nuevas funcionalidades? 💻 Traé tu compu porque la idea es meter mano en el proyecto. No hace falta haber contribuido antes. Y si ya lo hiciste, aprovechemos para reencontrarnos! 🤓"
        />

        <UqbarCard
          link="https://discord.com/channels/737094307902914570/840658205940121601/1478468397292322967"
          projectLogo={hackathonWollokUTN2026}
          projectName="Hackathon Wollok en UTN - FRBA"
          projectDescription="El sábado 7 de Marzo a las 10 hs nos encontramos en UTN - sede medrano a conocer más acerca de cómo está hecho Wollok. Traé tu compu porque la idea es contribuir al proyecto. Wollok se formó a partir de discusiones entre docentes y estudiantes. Si te interesa aportar ideas o formar parte de quienes definen la herramienta, este es tu lugar."
        />
      </UqbarCardGrid>


      <h2>2025</h2>
      <UqbarCard
        link="https://docs.google.com/document/d/e/2PACX-1vRP4cpaTBdel3Yrc6E9V6ia1NZTf31ufxa9D7wQ4msj5QjdZZJD0xXmUSVOzpjjhQ/pub"
        projectLogo={concursoWollokGame2025}
        projectName="Concurso Wollok Game 2025"
        projectDescription="Nos volvemos a encontrar en la ya 7ma edición del Concurso de Wollok Game. Esta vez con nuevo formato, les invitamos a presentar sus juegos y tanto el jurado como el público presente definirán los ganadores en vivo. Venite con tu juego y/o a jugar los juegos hechos en Wollok de este año. ¡Hasta pronto!"
      />

      <h2>2024</h2>
      <UqbarCardGrid>
        <UqbarCard
          link="https://discord.gg/jPMTCwZG3f"
          projectLogo={pharoOptimizations2024}
          projectName="Optimizaciones en la Máquina Virtual de Pharo"
          projectDescription={<>
            Nahuel vino de Francia para comentarnos cómo hace <a href="https://pharo.org/" target="_blank" rel="noopener noreferrer">Pharo</a> para ser eficiente ejecutando programas orientados a objetos. Nos presentará las optizaciones tradicionales en la industria y algunos de los experimentos que está haciendo con el equipo de la Máquina Virtual del lenguaje, en Inria.
          </>}
        />

        <UqbarCard
          link="https://docs.google.com/document/d/e/2PACX-1vS_--XeP1h6wVm6TB4NXwsV9_-w5Dvo9iXNU_kW83Q_vmvtmSEfGLl6MqQU0ejZq8CpNqI3dNHgSxui/pub"
          projectLogo={concursoWollokGame2024}
          projectName="Concurso Wollok Game 2024"
          projectDescription="Ya se viene la 6ta edición el evento más esperado por la comunidad: el Concurso de Wollok Game. Con ediciones cada vez más épicas, les invitamos a mandar sus juegos, votar a sus favoritos y llevarse premios piolas en un encuentro lleno de sorpresas. ¡Nos vemos pronto!"
        />
      </UqbarCardGrid>

      <h2>2023</h2>
      <UqbarCard
        link="https://docs.google.com/document/d/e/2PACX-1vQOapZd5M2xEoq6RR9PiHCynvIJ0A2SRlP_1wTy2I2-D7go7jSan8dAjTBs3C74SmKH-y80jnBoWpM3/pub"
        projectLogo={concursoWollokGame2023}
        projectName="Concurso Wollok Game 2023"
        projectDescription="¡Se hizo desear pero llegó el Concurso de Wollok Game 5ta edición! Así que ya sabés, si hiciste o estás haciendo un juego con Wollok Game, si estás aprendiendo a programar en objetos con Wollok y tenés ganas de explorar la interfaz gráfica de Game, si sos docente y querés mantenerte actualizado con las herramientas de Wollok, ¡este concurso es para vos! Junto con tu grupo, o individualmente, pueden hacer el juego que prefieran, presentarlo, que sea analizado por el jurado y que el público dé su opinión."
      />

      <h2>2022</h2>
      <UqbarCardGrid>
        <UqbarCard
          link="https://utn.zoom.us/j/87016722899"
          projectLogo={uqbarLogo}
          projectName="¡Cierre del año con Uqbar!"
          projectDescription="Martes 27 de Diciembre: Les invitamos a cerrar del año con nosotrxs. 
        Haremos un repaso de todas las cosas que se hicieron en Uqbar durante el año, y también presentaremos lxs ganadorxs del concurso Wollok Game 2022. La reunión será virtual en el link que se encuentra en la descripción de este evento. 
        ¡Lxs esperamos para brindar por otro año en comunidad!"
        />

        <UqbarCard
          link="https://docs.google.com/document/d/e/2PACX-1vQUxRzRAH_dUPMIO-N39x8F_mHDTa_DJb9ENgSxoEn4Ezb09PdzGr6pyD4UUv9Nm5-n1oVVBFD2B9Pu/pub"
          projectLogo={concursoWollokGame2022}
          projectName="Concurso Wollok Game"
          projectDescription="Si hiciste o estás haciendo un juego con Wollok Game, si estás aprendiendo a programar en objetos con Wollok y tenés ganas de explorar la interfaz gráfica de Game, si sos docente y querés mantenerte actualizado con las herramientas de Wollok, ¡este concurso es para vos! Junto con tu grupo, o individualmente, pueden hacer el juego que prefieran, presentarlo, que sea analizado por el jurado y que el público dé su opinión."
        />

        <UqbarCard
          link="https://www.instagram.com/p/ClHPR0vPE-7/?utm_source=ig_web_copy_link"
          projectLogo={unahurTic}
          projectName="UNAHUR@TIC"
          projectDescription='Encuentro de actualización Informática. Es una actividad que va a realizarse a en la Unahur @unahurlingham.
          📆 Sábado 19/11 Para destacar:
          ⏱11hs Débora Fortini "El software libre te lleva al mundial"
          ⏱14hs Gerardo Gonzalez Tulian "De wollok a ..."
          '
        />

        <UqbarCard
          link="https://docs.google.com/document/d/e/2PACX-1vR6zTgX7xcT_IMwnpO56kaDBLiafHFce4Y1P12kdN_Goyi2Pc6nlVLLkUf6DlrOgCVFF-TpZ27Rp1p2/pub"
          projectLogo={softwareLibre2022}
          projectName="Proyectos Innovadores con Software Libre"
          projectDescription="Aunque a veces es poco visible para el gran público por fuera de los especialistas informáticos, el software libre es un pilar fundamental para el funcionamiento de muchos de los recursos tecnológicos que usamos a diario, así como de los proyectos más innovadores y creativos. En esta jornada contaremos tres experiencias concretas de utilización de software libre para aplicaciones de alta demanda y complejidad, repasando las ventajas y los desafíos de haber encarado los diferentes proyectos con esa estrategia, así como los retos y objetivos de cara al futuro."
        />

        <UqbarCard
          link="https://docs.google.com/document/d/1FTdlT7WH3EJIC68BYJRkXeLhPQYAzg27Ya4t3RylOKs/edit?usp=sharing"
          projectLogo={maquinasVirtuales2022}
          projectName="Máquinas Virtuales Performantes y Robustas"
          projectDescription="En esta charla vamos a visitar las máquinas virtuales desde sus técnicas fundadoras hasta sus desafíos actuales usando la máquina virtual del lenguaje Pharo como ejemplo.
          La VM de Pharo esta escrita en Pharo mismo y basada en un sistema de simulación y transpilación.
          Vamos a empezar por los problemas de la interpretación, la traducción dinámica o compilación JIT, las cachés polimórficas, y la compilación adaptativa.
          Vamos a visitar la creación de compiladores usando técnicas de meta-compilación, y distintos ejemplos del problema de la validación de compiladores. Finalmente, vamos a discutir desafíos aun no resueltos con respecto a la ejecución manejada, la evaluación de performance, la gestion de memoria automática con hardware reciente y la seguridad."
        />
      </UqbarCardGrid>

      <h2>2021</h2>
      <UqbarCardGrid>
        <UqbarCard
          link="https://docs.google.com/document/d/e/2PACX-1vSxR8Kna9mxcXVJmcooGxPYok05MQUyj7eQwOeMPGCL48KujVS41vsYNyLDKsno1E7_EMCBQJ3aF3fS/pub"
          projectLogo={ultimoEvento2021}
          projectName="¡Último evento del año!"
          projectDescription="El próximo viernes 17 de diciembre, a las 18 horas, nos reuniremos de manera virtual para presentar los trabajos realizados a lo largo del año sobre nuestros diferentes proyectos y realizaremos el cierre del concurso de Wollok Game: ¡Ya finalizaron las inscripciones y es el momento de elegir a los juegos ganadores y entregarles sus premios!"
        />
        <UqbarCard
          link="https://docs.google.com/document/d/e/2PACX-1vTmBpmoVX52Kn2KKJME6AkZNoCZcqaMgrV9cRWDeG0Wc3zuT8BRFuahmFtoUeVXJfBfwCF8Mn4FrobP/pub"
          projectLogo={concursoWollokGame2021}
          projectName="Concurso Wollok Game 2021"
          projectDescription="Si hiciste o estás haciendo un juego con Wollok Game, si estás aprendiendo a programar en objetos con Wollok y tenés ganas de explorar la interfaz gráfica de Game, si sos docente y querés mantenerte actualizado con las herramientas de Wollok, ¡este concurso es para vos! Junto con tu grupo, o individualmente, pueden hacer el juego que prefieran, presentarlo, que sea analizado por el jurado y que el público dé su opinión."
        />
      </UqbarCardGrid>

      <h2>2020</h2>
      <UqbarCardGrid>
        <UqbarCard
          link="https://docs.google.com/document/d/e/2PACX-1vQKRcflFRkujk9JtQwC4njuVQm87VhlsdOrL7gD2yCr9ObbvBP1BJeIEZDkcMw5vQyHf2GV6WgvT0xR/pub"
          projectLogo={ultimoEvento2020}
          projectName="¡Último evento del año!"
          projectDescription="El próximo viernes 18 de diciembre, a las 19 horas, nos reuniremos de manera virtual para presentar los trabajos realizados a lo largo del año sobre nuestros diferentes proyectos y realizaremos el cierre del concurso Jugando con Wollok Game: ¡Ya finalizaron las inscripciones y es el momento de elegir a los juegos ganadores y entregarles sus premios!"
        />
        <UqbarCard
          link="https://docs.google.com/document/d/e/2PACX-1vRovuWOwqDfeF0CddazQwDGWlIAhVrvJJUYF45Jxnh5g5sL_lHIjy9xyv7kw8wCYaJmzM9x0kmVJCBd/pub"
          projectLogo={concursoWollokGame2020}
          projectName="Concurso Wollok Game 2020"
          projectDescription="Si hiciste o estás haciendo un juego con Wollok Game, si estás aprendiendo a programar en objetos con Wollok y tenés ganas de explorar la interfaz gráfica de Game, si sos docente y querés mantenerte actualizado con las herramientas de Wollok, ¡este concurso es para vos! Junto con tu grupo, o individualmente, pueden hacer el juego que prefieran, presentarlo, que sea analizado por el jurado y que el público dé su opinión."
        />
        <UqbarCard
          link="https://docs.google.com/document/d/e/2PACX-1vR0H_oeXpi7sVUwNQrdkwYqLOyY4stEBEAIkQlWEyCq7X_5lEHTSPZCgZUBdBFa1o4v3L5fivlhCz9q/pub"
          projectLogo={encuentroVirtual}
          projectName='Encuentros virtuales "Enseñando a programar" 2020'
          projectDescription="¿Qué estrategias usas para enseñar a programar?
¿Con qué problemas te encontrás?
¿Qué herramientas te son útiles?
Una serie de encuentros virtuales para dialogar sobre las experiencias educativas en torno a la enseñanza de la Programación"
        />
        <UqbarCard
          link="https://docs.google.com/document/d/e/2PACX-1vRcVrBm-xzDVPhR2CL1YsTK7xYRtT93KPSdisAaRq_KtERJjciRRl-cukJS0Sen87zVCSqflVD2DQRc/pub"
          projectLogo={convocatoriaDocente}
          projectName="Convocatoria Docente"
          projectDescription="¿Cuáles son los desafíos que se presentan al momento de enseñar programación? ¿Qué herramientas usamos dentro del aula? Desde la Fundación Uqbar nos interesa poder conversar sobre las experiencias educativas y reflexionar sobre los aprendizajes que se construyeron y se siguen construyendo en el contexto del aislamiento social preventivo obligatorio."
        />
      </UqbarCardGrid>

      <h2>2019</h2>
      <UqbarCardGrid>

        <UqbarCard
          link="https://docs.google.com/document/d/1hIyF7JHVLJ2u-a69tJRH5YfxPIdaiMDav3tCArkX-qc/view"
          projectLogo={concursoWollokGame2019}
          projectName="Concurso Wollok Game 2019"
          projectDescription="Si hiciste o estás haciendo un juego con Wollok Game, si estás aprendiendo a programar en objetos con Wollok y tenés ganas de explorar la interfaz gráfica de Game, si sos docente y queres mantenerte actualizado con las herramientas de Wollok, ¡este concurso es para vos! Junto con tu grupo, o individualmente, pueden hacer el juego que prefieran, presentarlo, que sea analizado por el jurado, que el público dé su opinión y ganar premios."
        />
        <UqbarCard
          link="https://docs.google.com/document/d/1rJdrULtkcoLSuSzcp98ishrMS_04xPBdVW0Gyp3llno/edit"
          projectLogo={jornadasDocentes}
          projectName="Jornada Enseñanza Programacion"
          projectDescription="Un espacio de formación para compartir experiencias y discutir estrategias, metodologías y recursos para enseñar a programar en instituciones educativas."
        />
      </UqbarCardGrid>
    </div>
  )
}
